"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _CloudReflash = _interopRequireDefault(require("@rsuite/icon-font/lib/network/CloudReflash"));

// Generated by script, don't edit it please.
var CloudReflash = (0, _createSvgIcon["default"])({
  as: _CloudReflash["default"],
  ariaLabel: 'cloud reflash',
  category: 'network',
  displayName: 'CloudReflash'
});
var _default = CloudReflash;
exports["default"] = _default;
module.exports = exports.default;